import { render, staticRenderFns } from "./MultipleInput.vue?vue&type=template&id=235b18b6&scoped=true"
import script from "./MultipleInput.vue?vue&type=script&lang=js"
export * from "./MultipleInput.vue?vue&type=script&lang=js"
import style0 from "./MultipleInput.vue?vue&type=style&index=0&id=235b18b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235b18b6",
  null
  
)

export default component.exports